var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dropdown-items",style:({ 'max-height': `${_vm.maxHeight}px` })},[_vm._t("default",null,{"maxHeight":_vm.maxHeight})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }